<template>
  <div>
    <Head :title="__(title)" />

    <div class="bg-white rounded-xl shadow-sm border border-gray-100 mb-4 ticket-filters-card">
      <div class="flex flex-col md:flex-row gap-3 p-4 justify-between items-center ticket-filters">
        <search-input v-model="form.search" class="w-full max-w-md" @reset="reset" />
      </div>
    </div>

    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-x-auto">
      <table class="w-full whitespace-nowrap ticket_list">
        <tr class="text-left font-bold">
          <th>{{ __('Name') }}</th>
          <th>{{ __('Email') }}</th>
          <th>{{ __('Phone') }}</th>
          <th>{{ __('City') }}</th>
          <th>{{ __('Address') }}</th>
          <th>{{ __('Registered') }}</th>
          <th colspan="2">{{ __('Action') }}</th>
        </tr>
        <tr v-for="user in users" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100 ticket-row">
          <td class="border-t">
            <div class="flex items-center gap-2 px-4 py-2">
              <div class="um-avatar">
                <span class="um-avatar-initials">{{ (user.first_name || '?')[0].toUpperCase() }}</span>
              </div>
              <span class="text-sm font-medium">{{ properName(user.first_name + ' ' + user.last_name) }}</span>
            </div>
          </td>
          <td class="border-t">
            <div class="flex items-center px-4 py-2 text-sm">{{ user.email }}</div>
          </td>
          <td class="border-t">
            <div class="flex items-center px-4 py-2 text-sm">{{ user.phone || '—' }}</div>
          </td>
          <td class="border-t">
            <div class="flex items-center px-4 py-2 text-sm">{{ __(user.city) || '—' }}</div>
          </td>
          <td class="border-t">
            <div class="flex items-center px-4 py-2 text-sm capitalize">{{ user.address || '—' }}</div>
          </td>
          <td class="border-t">
            <div class="flex items-center px-4 py-2 text-sm">{{ moment(user.created_at).fromNow() }}</div>
          </td>
          <td class="border-t">
            <div class="flex items-center gap-2 px-4 py-2">
              <button @click="approveAccount(user.id)" class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-green-50 text-green-700 border border-green-200 hover:bg-green-100 transition-colors">
                <icon name="tick" class="w-4 h-4" />
                {{ __('Approve') }}
              </button>
              <button @click="removeAccount(user.id)" class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-red-50 text-red-700 border border-red-200 hover:bg-red-100 transition-colors">
                <icon name="cross" class="w-4 h-4" />
                {{ __('Decline') }}
              </button>
            </div>
          </td>
        </tr>
        <tr v-if="users.length === 0">
          <td class="px-4 py-3 border-t text-sm text-gray-500" colspan="8">{{ __('No pending users found.') }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchInput from '@/Shared/SearchInput'
import moment from 'moment'
import axios from 'axios'

export default {
  components: {
    SearchInput,
    Head,
    Icon,
    Link,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Array,
    title: String,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('pending_users'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    approveAccount(id) {
      axios.get(this.route('pending.active', { id })).then(() => {
        window.location.reload()
      })
    },
    removeAccount(id) {
      axios.get(this.route('pending.decline', { id })).then(() => {
        window.location.reload()
      })
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
  created() {
    this.moment = moment
  },
}
</script>
